up.NotImplemented = class NotImplemented extends up.Error {
};
